<template>
    <div class="container"  >
      <section class=" order-listing-header-main px-sm-0  px-1  ">  
        <div class=" d-flex align-items-center justify-content-between header-elements-inline pb-0">
          <h2 class="fs-38 card-title text--dark--custom font-weight-black text-capitalize">
              {{this.$route.params.status}} Classes
          </h2>
          <div class="header-elements my-2">
            <router-link :to="{ name: 'AddClass' }" style="color: #fff!important;  " class="btn mx-0 font--weight px-3 btn--secondary--order flex-row d-flex align-items-center justify-content-center px-3 py-2" @click="doPlaceOrder">
                
                New Class
              </router-link>
          </div>
        </div>
      
      </section>
      <BaseLoading
        style="min-height: 400px; height: 90vh"
        v-if="loading"
      ></BaseLoading>
      
  
      <div v-else  class=" " >
        <!-- {{ classHelp }} -->
        </div> 
        <div class="card orderlisting--card pb-2">
  
          <!-- <div  v-if="isEditable && bulkActionIds.length > 0" class=" px-3  py-3 text-right py-0" style="">
            <div class="row">
              <div class="col-12 col-sm-8 text-left">
                <div
                  v-if="isEditable && bulkActionIds.length > 0"
                  class="d-flex flex-row align-items-center"
                >
                  <span
                    class="badge"
                    style="
                      height: 22px;
                      text-align: center;
                      vertical-align: middle !important;
                      border: 1px solid rgb(32 150 243);
                      color: rgb(32 150 243);
                      background: rgb(32 150 243 / 21%);
                      width: 22px;
                      padding: 3px;
                    "
                  >
                    <span class="icon-check"></span>
                  </span>
                  <label class="my-1 ml-1"
                    >{{ bulkActionIds.length }} Orders Selected</label
                  >
  
                  <button
                  style="border-radius:50px!important; width: 150px; "
                    @click="bulkAction('pay')"
                    class="btn btn-block btn--custom px-3 ml-2"
                  >
                    Pay
                  </button>
                 
                </div>
              </div>
            </div>
          </div> -->
          <div v-if="classHelp.length > 0" class=" mx-0   order-table-custom ">
          
            <div  class=" order-listing-header  row  p-3 mx-sm-0 mx-1 ">  
              <div class="col-2 text-left text--dark--custom "> Order Id </div>
              <div class="col-2 text-left text--dark--custom ">Pages</div>
              <div class="col-2 text-left text--dark--custom">Weeks</div>
              <div class="col-3 text-left text--dark--custom"> Status</div>
              <div class="col-3 text-left text--dark--custom">Action </div>
          </div>

          <!-- {{ classHelp }} -->
        
          <div v-if="classHelp.length > 0" class="">
          <div v-for="(item, index) in classHelp" :key="index + 'ords'" class="order-listing-body row px-3 py-3 mx-sm-0 mx-1 ">  
              <div class="col-2 d-flex align-items-start justify-content-start text-left">
                
                <router-link class="px-2"
                :to="{ name: 'ViewClass', params: { id: item.id } }"
                  >#{{ item.id || "" }}</router-link>
                
              </div>
              <div class="col-2 text-left">
                {{item.no_pages}} Pages
              </div>
              <div class="col-2 text-left">{{ item.no_weeks || "" }} Weeks</div>
              <div class="col-3 text-left">
                <span v-html="item.status" ></span>
              </div>
              <div class="col-3 text-left">
                <router-link
                class="btn btn-outline-primary btn-sm"
                :to="{ name: 'ViewClass', params: { id: item.id } }"
                >View</router-link>
              </div>
             
          </div>
          </div>
  
          </div>
          <div  v-if="classHelp.length < 1">
            
                <strong style="text-transform:capitalize!important;" class="order_empty  text-center" >No {{ this.$route.params.status }} Class </strong>
            
          </div>
  
          
        </div>
       
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  export default {
    name: "MyClasses",
    computed: {
      ...mapState("orders", ["orders", "classes", "classHelp", "filters"]),
      ...mapState("sidebar", ["showSidebar", "sidebarMenu"]),
  
      isEditable() {
        if (this.$route.params.status == "unpaid") {
          return true;
        } else return false;
      },
    },
  
    data() {
      return {
        loading: false,
        bulkActionIds: [],
      };
    },
  
    beforeRouteUpdate(to, from, next) {
      this.loading = true;
      let payload = to.params && to.params.status ? to.params.status : "editing";
      this._getClassesStatus(payload)
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
      next();
    },
  
    mounted() {
      this.loading = true;
      // console.log(this.$route.params.status);
      this.getSidebarMenu();
      this._getClasses()
      this._getClassesStatus(this.$route.params.status || "editing")
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
  
    methods: { 
      ...mapActions("orders", ["_getClassesStatus", "_getClasses", "_navigate"]),
      ...mapActions("sidebar", ["getSidebarMenu"]),
  
  
      bulkAction(action) {
        if (action == "pay") {
          console.log("bulkActionIds", this.bulkActionIds);
          this.$router.push({
            name: "BulkCheckout",
            params: {
              ids: JSON.stringify(this.bulkActionIds),
            },
          });
        }
      },
      navigate(route) {
        this.loading = true;
        this._navigate(route)
          .catch((err) => console.log(err))
          .finally(() => (this.loading = false));
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .is-title {
    max-height: 3px !important;
    overflow-y: hidden;
    line-height: 1.5;
    overflow: hidden;
  }
  td {
    padding: 2px !important;
  }
  </style>
  